import React from "react";
import PropTypes from "prop-types";
import { Layout as AntdLayout } from "antd";
import Drawer from "./Drawer";
import Breadcrumb from "./Breadcrumb";
import Context from "./Context";
import Footer from "./Footer";
import SideNav from "./SideNav";
import Nav from "./Nav";
import "antd/dist/antd.css";
import "mdi/css/materialdesignicons.min.css";
import "assets/app/app.css";
import Profile from "../../routes/Home/Profile/Profile";

export default class RLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      sideNavCollapsed: true,
    };
  }

  /**
   * @param {Boolean} toggled
   */
  onSideNavToggle(toggled) {
    this._setSideNavCollapsed(!toggled);
  }

  /**
   *
   * @param {Boolean} sideNavCollapsed
   * @private
   */
  _setSideNavCollapsed(sideNavCollapsed) {
    //  console.log(sideNavCollapsed);
    this.setState({
      sideNavCollapsed,
    });
  }

  /**
   * @return {XML}
   */
  render() {
    const { sideNavCollapsed } = this.state;
    const { children } = this.props;
    let isFirstLogin = JSON.parse(
      localStorage.getItem("isFirstLogin") || "false"
    );

    //  isFirstLogin;
    return (
      <AntdLayout className="wrapper">
        <Nav onHamburgerToggle={this.onSideNavToggle} />

        {!isFirstLogin ? (
          <AntdLayout className="ant-layout-has-sider">
            <Drawer />

            <AntdLayout>
              <Breadcrumb />

              <Context>{children}</Context>

              <Footer />
            </AntdLayout>

            <SideNav
              collapsed={sideNavCollapsed}
              setCollapsed={this._setSideNavCollapsed}
            />
          </AntdLayout>
        ) : (
          <Profile />
        )}
      </AntdLayout>
    );
  }
}
